<template>
  <div class="card-head">
    <div class="clearfix">
      <div class="column column-total">
        <div class="column-hd">
          <span class="column-hd__title">账户总额</span>
          <span class="wallet-explain" @click="walletExplainDialogVisible=true">钱包说明</span>
        </div>
        <div class="column-bd">
          <span class="money-label">￥</span>
          <span class="money-number">{{ formatMoney(walletInfo.totalAmount) }}</span>
        </div>
      </div>
    </div>

    <div class="clearfix">
      <div class="column column-cash fl">
        <div class="column-hd">
          <span class="column-hd__title">可提现金额</span>
          <img class="icon-query" src="../../../assets/wallet/query.png" @click="withdrawDialogVisible=true">
        </div>
        <div class="column-bd">
          <span class="money-label">￥</span>
          <span class="money-number">{{ formatMoney(walletInfo.withdrawAbleAmount) }}</span>
          <div class="cash-button" @click="guideToAppDialogVisible=true">提现</div>
        </div>
      </div>
      <div class="column column-frozen fl">
        <div class="column-hd">
          <span class="column-hd__title">冻结金额</span>
          <img class="icon-query" src="../../../assets/wallet/query.png" @click="frozenDialogVisible=true">
        </div>
        <div class="column-bd">
          <span class="money-label">￥</span>
          <span class="money-number">{{ formatMoney(walletInfo.freezingAmount) }}</span>
        </div>
      </div>

      <div class="column column-wait fr">
        <div class="column-hd">
          <span class="column-hd__title">待入账金额</span>
          <img class="icon-query" src="../../../assets/wallet/query.png" @click="waitingDialogVisible=true">
        </div>
        <div class="column-bd">
          <span class="money-label">￥</span>
          <span class="money-number">{{ formatMoney(walletInfo.accountedAmount) }}</span>
        </div>
      </div>
    </div>
    <div class="line"></div>

    <!-- 可提现金额说明弹窗 -->
    <el-dialog class="dialog dialog--withdraw" title="可提现金额" :visible.sync="withdrawDialogVisible" top="10%">
      <p>可提现金额可直接申请提现到您的支付宝、微信。</p>
      <button class="dialog__btn" @click="withdrawDialogVisible=false">我知道了</button>
    </el-dialog>

    <!-- 冻结金额说明弹窗 -->
    <el-dialog class="dialog dialog--frozen" title="冻结金额" :visible.sync="frozenDialogVisible" top="10%">
      <p>冻结金额可用于回收下单加价，参与限时活动，限时兑换为可提现金额等。</p>
      <button class="dialog__btn" @click="frozenDialogVisible=false">我知道了</button>
    </el-dialog>

    <!-- 待入账金额说明弹窗 -->
    <el-dialog class="dialog dialog--waiting" title="待入账金额" :visible.sync="waitingDialogVisible" top="10%">
      <p class="desc">回收订单下单后，所估价价格将会计入待入账金额，议价完成后将会转入可提现金额。</p>
      <p class="font-weight" v-if="walletInfo">待入账金额:<span class="waiting-number">￥{{ formatMoney(walletInfo.accountedAmount) }}</span></p>
      <p class="font-weight" v-if="walletInfo">当前有{{ walletInfo.orderCount || 0 }}笔订单未完成</p>
      <button class="dialog__btn" @click="goOrderList">我知道了</button>
    </el-dialog>

    <!-- 引导去APP或公众号弹窗 -->
    <el-dialog
      class="dialog dialog--download"
      :visible.sync="guideToAppDialogVisible"
      top="10%"
    >
      <img src="../../../assets/wallet/exchange_img_fail@1x.png">
      <h3 class="title">提现</h3>
      <p class="desc">为保证您的账户安全，需要在App或公众号进行提现。</p>
      <img class="icon-qr" src="https://s1.huishoubao.com/static/pc/1001/img/code.png">
      <span class="img-text img-text-app">下载App</span>
      <span class="img-text img-text-wx">关注公众号</span>
    </el-dialog>

    <!-- 钱包说明弹窗 -->
    <el-dialog
      class="dialog dialog--wallet text-center"
      title="钱包说明"
      :visible.sync="walletExplainDialogVisible"
      top="10%"
    >
      <WalletExplain></WalletExplain>
    </el-dialog>
  </div>
</template>

<script>
import { getBalanceInfo } from '@/apis/base';
import { Dialog, Button, Message } from 'element-ui';
import WalletExplain from './wallet-explain';

export default {
  components: {
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    WalletExplain
  },
  data () {
    return {
      walletInfo: {},
      withdrawDialogVisible: false,
      frozenDialogVisible: false,
      waitingDialogVisible: false,
      guideToAppDialogVisible: false,
      walletExplainDialogVisible: false
    };
  },
  methods: {
    formatMoney (num) {
      num = num || 0;
      return (num / 100).toFixed(2);
    },
    goOrderList (key) {
      this.waitingDialogVisible = false;
      this.$router.push('/Account/OrderList');
    }
  },
  async mounted () {
    let result = await getBalanceInfo();
    if (result.success) {
      this.walletInfo = result._data;
    } else {
      Message.error(`获取钱包信息失败：${result._errStr}`);
    }
  }
};
</script>

<style lang="postcss" scoped>

.dialog {
  /deep/ .el-dialog {
    width: 376px;
    text-align: center;
    background: #FFFFFF;
    border-radius: 8px;
    &__title {
      font-size: 16px;
      font-weight: bold;
      color: #2B2D2E;
    }
    &__body {
      padding-left: 24px;
      padding-right: 24px;
      padding-bottom: 24px;
      padding-top: 20px;
      line-height: 20px;
      color: #2B2D2E;
      text-align: left;
    }
    &__header {
      padding-bottom: 0;
    }
  }
  .dialog__btn {
    width: 328px;
    height: 48px;
    line-height: 48px;
    font-size: 16px;
    margin-top: 24px;
    color: #2B2D2E;
    background: #FFDA05;
    border-radius: 3px;
    border: 0;
    outline: 0;
    cursor: pointer;
  }
}

.dialog--waiting {
  .desc {
    margin-bottom: 12px;
  }
}

.dialog--download {
  /deep/ .el-dialog__body {
    text-align: center;
  }
  /deep/ .el-dialog {
    width: 604px;
    height: 430px;
  }
}

.waiting-number {
  font-size: 14px;
  color: #FF3405;
}

.font-weight {
  font-weight: bold;
}

.text-center {
  text-align: center;
}

@mixin leftFlag {
  position: relative;
  display: inline-block;
  padding-left: 14px;
  &:before {
    content: " ";
    display: block;
    width: 6px;
    height: 6px;
    position: absolute;
    left: 0;
    top: 7px;
    background: #FFDA05;
    border-radius: 50%;
  }
}

@mixin line {
  width: 100%;
  height: 1px;
  background: #E9EBED;
}

.card-head {
  overflow: hidden;
}

.column-frozen .label {
  @include leftFlag;
  &:before {
    background: #333333;
  }
}

.line {
  @include line;
}

.column-frozen {
  margin-left: 140px;
}

.column-wait {
  .column-hd__title::before {
    background: #FF4B00;
  }
}

.column {
  color: #2B2D2E;
  -webkit-text-size-adjust: none;
  &-hd {
    &__title {
      @include leftFlag;
      font-size: 14px;
      line-height: 20px;
      color: #2B2D2E;
      .column-cash &:before {
        background: #5C3BFF;
      }
      .column-frozen &:before {
        background: #0074E4;
      }
    }
  }
  &-bd {
    padding-top: 12px;
    padding-bottom: 40px;
  }
}

.wallet-explain {
  font-size: 9px;
  padding: 2px 6px;
  border-radius: 8.5px;
  background: #FFDA05;
  cursor: pointer;
}

.money-label {
  font-size: 16px;
}

.money-number {
  font-size: 30px;
}

.cash-button {
  display: inline-block;
  width: 80px;
  height: 32px;
  line-height: 32px;
  margin-left: 40px;
  text-align: center;
  border: 1px solid #333333;
  border-radius: 4px;
  cursor: pointer;
}

.dialog--download {
  color: #2B2D2E;
  .icon-qr {
    display: block;
    width: 360px;
    margin: 0 auto;
    margin-top: 30px;
  }
  .img-text {
    font-size: 16px;
    font-weight: bold;
  }
  .img-text-app {
    float: left;
    margin-left: 150px;
    margin-top: 20px;
  }
  .img-text-wx {
    float: right;
    margin-right: 137px;
    margin-top: 20px;
  }
  .desc {
    margin-top: 8px;
    font-size: 16px;
  }
  /deep/ .el-dialog__body {
    padding-top: 0;
  }
}

.dialog--wallet {
  /deep/ .el-dialog__header {
    height: 70px;
    padding-top: 0;
    padding-bottom: 0;
    line-height: 70px;
    background: #FFDA05;
    border-radius: 8px;
  }
  /deep/ .el-dialog {
    width: 442px;
  }
}

.icon-query {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/account/wallet/cardHead.vue